import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';

import type { CandidateMailFolder } from '../constants';

export default function useCandidateMailNavigation() {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      openFolder: (folder: CandidateMailFolder, options?: { replace?: boolean }) =>
        navigate({ to: '/agent/candidate_mails', search: { folder }, replace: options?.replace }),
      openMail: (folder: CandidateMailFolder, mailId: number) =>
        navigate({ to: '/agent/candidate_mails', search: { folder, mailId } }),
      openTemplate: (templateId: number, options?: { replace?: boolean }) =>
        navigate({
          to: '/agent/candidate_mails',
          search: { folder: 'templates', templateId },
          replace: options?.replace,
        }),
      compose: (options?: { replace?: boolean }) =>
        navigate({ to: '/agent/candidate_mails/new', replace: options?.replace }),
      createTemplate: (sourceId?: number) =>
        navigate({ to: '/agent/candidate_mails/templates/new', search: { sourceId } }),
      editTemplate: (templateId: number) =>
        navigate({
          to: '/agent/candidate_mails/templates/$templateId/edit',
          params: { templateId: String(templateId) },
        }),
    }),
    [navigate]
  );
}
